/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { GroupYachtBookingList as BookingListMole } from "../../molecules";
import { GroupYachtBookingWrapper } from "./GroupYachtBooking.style";
import { GroupYachtBookingListToolbar } from "./GroupYachtBookingListToolbar";

export const GroupYachtBookingList: React.FC = () => {
  const { bookingGroupYachts } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookingGroupYachts;
    return bookingGroupYachts.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookingGroupYachts, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <GroupYachtBookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <GroupYachtBookingWrapper>
        <BookingListMole bookings={filteredBookings} loading={loading} />
      </GroupYachtBookingWrapper>
    </AdminPageBody>
  );
};
